import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'
import { useQueryClient } from '@tanstack/react-query'

const useUpdatePlatformAppClientDetailsMutation = createMutationHook(
  PlatformAppsApiClient.updatePlatformAppClientDetails,
  {
    mutationKey: ['updatePlatformAppClientDetails'],
  },
)

export const useUpdatePlatformAppClientDetails = () => {
  const queryClient = useQueryClient()
  const { updatePlatformAppClientDetailsMutation } = useUpdatePlatformAppClientDetailsMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platformAppClients'] })
      queryClient.invalidateQueries({ queryKey: ['platformAppClient'] })
    },
  })

  return {
    updatePlatformAppClientDetails: updatePlatformAppClientDetailsMutation.mutate,
    isLoading: updatePlatformAppClientDetailsMutation.isLoading,
  }
}
